import React from "react";
import { StatusTagTemplate } from "themes/common/components";

function StatusTag(props) {
    return <StatusTagTemplate {...props} />;
}

export default StatusTag;
